import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { UsuarioListarComponent } from './usuario-listar.component'; 
import { UsuarioListarRoutingModule } from './usuario-listar-routing.module'; 
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';


@NgModule({
 
  imports: [
    CommonModule,    
    TableModule,
    HttpClientModule,
    UsuarioListarRoutingModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DividerModule,
    ProgressSpinnerModule,
    MessagesModule
  ],
  declarations: [
    UsuarioListarComponent
  ],
  exports: [
    UsuarioListarComponent
  ]
})
export class UsuarioListarModule { }
